<script lang="ts">
  import { Button as ButtonPrimitive } from 'bits-ui'
  import { type Events, type Props, buttonVariants } from './variants'
  import { cn } from '$lib/cn'

  type $$Props = Props
  type $$Events = Events

  let className: $$Props['class'] = undefined
  export let variant: $$Props['variant'] = 'default'
  export let size: $$Props['size'] = 'default'
  export let builders: $$Props['builders'] = []
  /**
   * Called from the forwarded click rather than spread onto the element. Spread,
   * it becomes a delegated handler, and Svelte skips delegated handlers on an
   * element that also has an `on:click` listener once the event is outside the
   * app root, so inside a portalled dialog or sheet a click on the label never
   * reached it.
   */
  export let onclick: $$Props['onclick'] = undefined
  export { className as class }

  /* The handler type is a union over the anchor and button forms this renders,
     so it is applied rather than called with a `this` of one form. */
  function handleClick(event: MouseEvent) {
    if (onclick) Reflect.apply(onclick, event.currentTarget, [event])
  }
</script>

<ButtonPrimitive.Root
  {builders}
  class={cn(buttonVariants({ variant, size, class: className as string }))}
  type="button"
  {...$$restProps}
  on:click
  on:click={handleClick}
  on:keydown
>
  <slot />
</ButtonPrimitive.Root>
